module.exports = __webpack_public_path__ + "img/icon-check.e0eddd65.svg";